var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"inner-navigation"},_vm._l((_vm.links),function(link,idx){return _c('li',{key:idx},[_c('router-link',{attrs:{"to":link.to,"active-class":"active"}},[_vm._v("\n      "+_vm._s(link.label)+"\n    ")])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }